import { useCreateBusiness } from "@api/businessService";
import BusinessEdit from "./BusinessEdit";

const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
let initialHours = [];
for(const day of daysOfWeek) {
    initialHours.push({
        day,
        open_time: null,// new Date(),
        close_time: null,// new Date(),
        is_closed: 1,
    });
}

export default function BusinessCreate() {
    return <BusinessEdit
        mutation={useCreateBusiness}
        title={'New Business'}
        create
        initialData={{
            hours: initialHours
        }}
    />
}
